/**
 * @generated SignedSource<<620ea882636c6674f5a09db5334a4f74>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelSwitchQueriesCheckSellerPlanQuery$variables = Record<PropertyKey, never>;
export type salesChannelSwitchQueriesCheckSellerPlanQuery$data = {
  readonly hasPodProducts: boolean;
  readonly modelsCount: number;
};
export type salesChannelSwitchQueriesCheckSellerPlanQuery = {
  response: salesChannelSwitchQueriesCheckSellerPlanQuery$data;
  variables: salesChannelSwitchQueriesCheckSellerPlanQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "environment",
        "value": 2
      }
    ],
    "kind": "ScalarField",
    "name": "modelsCount",
    "storageKey": "modelsCount(environment:2)"
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasPodProducts",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSwitchQueriesCheckSellerPlanQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "salesChannelSwitchQueriesCheckSellerPlanQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "b5fc3ae3c480e6c0e40b89fcd7518712",
    "id": null,
    "metadata": {},
    "name": "salesChannelSwitchQueriesCheckSellerPlanQuery",
    "operationKind": "query",
    "text": "query salesChannelSwitchQueriesCheckSellerPlanQuery {\n  modelsCount(environment: 2)\n  hasPodProducts\n}\n"
  }
};
})();

(node as any).hash = "1af2e71168cc35bddfc55ce578f147b0";

export default node;
